import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input } from "reactstrap";

const EditSampleModal = ({ isOpen, toggle, sample, onSave, categoryOptions }) => {
  const [formData, setFormData] = useState({
    category: "",
    testKitTypes: "",
    IHProductId: "",
    labName: "",
    productName: "",
    labProfileId: ""
  });

  const testKitTypeOptions = [
    { value: 1, label: "Male" },
    { value: 2, label: "Female" }
  ];

  useEffect(() => {
    if (sample) {
      setFormData({
        category: sample.category || "",
        testKitTypes: sample.testKitTypes || "",
        IHProductId: sample.IHProductId || "",
        labName: sample.labName || "",
        productName: sample.productName || "",
        labProfileId: sample.labProfileId || ""
      });
    }
  }, [sample]);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    const updateData = {};
    
    if (formData.category && Number(formData.category) !== Number(sample.category)) {
      updateData.category = Number(formData.category);
    }
    if (formData.testKitTypes && Number(formData.testKitTypes) !== Number(sample.testKitTypes)) {
      updateData.testKitType = Number(formData.testKitTypes);
    }
    if (formData.IHProductId.trim() !== (sample.IHProductId || "").trim()) {
      updateData.IHProductId = formData.IHProductId.trim();
    }
    if (formData.labName.trim() !== (sample.labName || "").trim()) {
      updateData.labName = formData.labName.trim();
    }
    if (formData.productName.trim() !== (sample.productName || "").trim()) {
      updateData.productName = formData.productName.trim();
    }
    if (formData.labProfileId.trim() !== (sample.labProfileId || "").trim()) {
      updateData.labProfileId = formData.labProfileId.trim();
    }

    onSave(sample.sampleId, updateData);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        Edit Sample - {sample?.sampleId}
      </ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label>Category</Label>
          <Input
            type="select"
            value={formData.category}
            onChange={(e) => handleChange("category", e.target.value)}
          >
            <option value="">Select Category</option>
            {categoryOptions && categoryOptions.map(opt => (
              <option key={opt.id || opt.value} value={opt.id || opt.value}>{opt.label}</option>
            ))}
          </Input>
        </FormGroup>

        {(formData.category === 1 || formData.category === "1") && (
          <FormGroup>
            <Label>Test Kit Type</Label>
            <Input
              type="select"
              value={formData.testKitTypes}
              onChange={(e) => handleChange("testKitTypes", e.target.value)}
            >
              <option value="">Select Test Kit Type</option>
              {testKitTypeOptions.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </Input>
          </FormGroup>
        )}

        <FormGroup>
          <Label>IH Product ID</Label>
          <Input
            type="text"
            value={formData.IHProductId}
            onChange={(e) => handleChange("IHProductId", e.target.value)}
            placeholder="Enter IH Product ID"
          />
        </FormGroup>

        <FormGroup>
          <Label>Lab Name</Label>
          <Input
            type="text"
            value={formData.labName}
            onChange={(e) => handleChange("labName", e.target.value)}
            placeholder="Enter Lab Name"
          />
        </FormGroup>

        <FormGroup>
          <Label>Product Name</Label>
          <Input
            type="text"
            value={formData.productName}
            onChange={(e) => handleChange("productName", e.target.value)}
            placeholder="Enter Product Name"
          />
        </FormGroup>

        <FormGroup>
          <Label>Lab Profile ID</Label>
          <Input
            type="text"
            value={formData.labProfileId}
            onChange={(e) => handleChange("labProfileId", e.target.value)}
            placeholder="Enter Lab Profile ID"
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSubmit}>
          Save Changes
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditSampleModal;
